const CommonCMS = {
    shared: "shared",
    page: "page",
    offers: "offers",
    total: "uiText.total",
    subtotal: "uiText.subtotal",
    discount: "uiText.discount",
    shipping: "uiText.shipping",
    ariaLabels: {
        homeButtonAria: "aria.homeButton",
        navigationAria: "aria.navigation",
        breadcrumbAria: "aria.breadcrumb",
        closeModalAria: "aria.closeModal",
        skipLinkTextAria: "skipLinkText",
        viewProductAria: "aria.viewProduct",
    },
    liveChat: {
        title: "uiText.liveChat.title",
        needHelp: "uiText.liveChat.needHelp",
        getStarted: "uiText.liveChat.getStarted",
        description: "uiText.liveChat.description",
        startChatting: "uiText.liveChat.startChatting",
        reason: "uiText.liveChat.reason",
        placeholder: { reason: "uiText.liveChat.reasonPlaceholder" },
        chatIsOffline: "uiText.liveChat.chatIsOffline",
        chatOfflineDescription: "uiText.liveChat.chatOfflineDescription",
        exit: "uiText.liveChat.exit",
    },
    navigationMenu: {
        ariaButtonOpenMenu: "aria.openNavMenu",
        ariaButtonCloseMenu: "aria.closenNavMenu",
    },
    salesTax: {
        title: "uiText.salesTax.title",
        info: "uiText.salesTax.info",
    },
    salesDays: {
        blackFriday: "uiText.salesDays.blackFriday",
        cyberMonday: "uiText.salesDays.cyberMonday",
    },
    PLP: {
        sortByLabel: "PLP.dialog.sortByLabel",
    },
    PDP: {
        itemNumber: "uiText.PDP.itemNumber",
        featuresAndBenefits: "uiText.PDP.featuresAndBenefits",
        deliveryAndReturnsHeader: "uiText.PDP.deliveryAndReturnsHeader",
        deliveryAndReturns: "uiText.PDP.deliveryAndReturns",
        soldOutTitle: "PDP.itemSoldOutTitle",
        soldOutSubtitle: "PDP.itemSoldOutSubtitle",
        addToCart: "PDP.addToCart",
        pleaseSelectSize: "PDP.pleaseSelectSize",
        reviews: "uiText.PDP.reviews",
        writeFirstReview: "uiText.PDP.writeFirstReview",
        dragToRotate: "uiText.PDP.dragToRotate",
        clickToRotate: "uiText.PDP.clickToRotate",
    },
    price: {
        previousLowestPrice: "price.previousLowestPrice",
        recommendedPrice: "price.recommendedPrice",
        adjustedPrice: "price.previousSalePrice",
        includesTaxes: "price.includesTaxes",
    },
    size: {
        title: "uiText.size.title",
        select: "uiText.size.select",
        labelEU: "uiText.sizeLabelEU",
        labelUS: "uiText.sizeLabelUS",
        labelUK: "uiText.sizeLabelUK",
        labelCM: "uiText.sizeLabelCM",
        labelKR: "uiText.sizeLabelKR",
        labelCA: "uiText.sizeLabelCA",
        labelJP: "uiText.sizeLabelJP",
        labelCN: "uiText.sizeLabelCN",
        ariaEU: "aria.sizeLabelUK",
        ariaUS: "aria.sizeLabelUS",
        ariaUK: "aria.sizeLabelUK",
        ariaCM: "aria.sizeLabelCM",
        ariaKR: "aria.sizeLabelKR",
        ariaCA: "aria.sizeLabelCA",
        ariaJP: "aria.sizeLabelJP",
        ariaCN: "aria.sizeLabelCN",
        guideModalTitle: "sizeGuideModal.title",
    },
    gender: {
        title: "uiText.gender.title",
        male: "uiText.gender.male",
        female: "uiText.gender.female",
        neutral: "uiText.gender.neutral",
    },
    guide: {
        male: "male",
        female: "female",
        unisex: "unisex",
        kids: "kids",
        laces: "laces",
        belts: "belts",
        socks: "socks",
        gloves: "gloves",
        shoeCare: "shoeCare",
    },
    promoCode: {
        title: "uiText.promoCode.title",
        apply: "uiText.promoCode.button.apply",
        error: "uiText.promoCode.error",
        unusable: "uiText.promoCode.nolongervalid",
        remove: "uiText.promoCode.remove",
        removeAria: "uiText.promoCode.removeAria",
        applyAria: "uiText.promoCode.applyAria",
        warrantyCodeError: "uiText.promoCode.warrantyCodeError",
        warrantyCodeNotification: "uiText.promoCode.warrantyCodeNotificaiton",
        discountApplied: "uiText.promoCode.discountApplied",
    },
    product: "product",
    products: "products",
    productPagination: "product.pagination",
    productsPagination: "products.pagination",
    color: "product.color",
    colors: "product.colors",
    colorIs: "uiText.colorIs",
    inSize: "uiText.inSize",
    quantity: {
        title: "uiText.quantity.title",
        select: "uiText.quantity.select",
    },
    openCountrySelector: "ariaLabel.openCountrySelector",
    countrySelector: "ariaLabel.countrySelector",
    countrySelectorItem: "ariaLabel.countrySelectorItem",
    youMightAlsoLikeMC: "PDP.youMightAlsoLike",
    recentlyViewedMC: "PDP.recentlyViewed",
    backText: "uiText.backText",
    addedToBagTitle: "uiText.addedToBag.title",
    ccpItemsTitle: "uiText.ccpItemsTitle",
    sraItemsTitle: "uiText.sraItemsTitle",
    email: "uiText.email",
    subscribeButton: "uiText.subscribeButton",
    password: "uiText.password",
    firstName: "uiText.firstName",
    lastName: "uiText.lastName",
    phoneticFirstName: "uiText.phoneticFirstName",
    phoneticLastName: "uiText.phoneticLastName",
    dateOfBirth: "uiText.dateOfBirth",
    requiredLabel: "uiText.requiredLabel",
    country: "checkout.step1.formCountry.title",
    phone: "checkout.step1.formPhone.title",
    passwordRules: "uiText.passwordRules",
    resetPassword: "uitext.resetPassword",
    resetPassDesc: "text.resetPasswordDescription",
    resetPasswordSentText: "uiText.ResetPasswordSuccess",
    resetEmailSentThanks: "uiText.ResetPasswordThanks",
    sendResetPasswordButton: "uiText.sendResetPasswordButton",
    backToLogin: "uiText.backToLogin",
    resetPasswordLink: "linkRoute.resetPassword",
    resetEmailSentSuccess: "text.resetEmailSentSuccessDescription",
    profile: {
        overview: "uiText.profile.overview",
        newPassword: "uiText.profile.newPassword",
        currentPassword: "uiText.profile.currentPassword",
        confirmPassword: "uiText.profile.confirmPassword",
        changePassword: "uiText.profile.changePassword",
        redirectToLogIn: "uiText.profile.redirectToLogIn",
        passwordWasUpdated: "uiText.profile.passwordWasUpdated",
    },
    accessibilityActivate: "accessibility.Activate",
    accessibilityDeactivate: "accessibility.Deactivate",
    accessibilityFeedback: "accessibility.Feedback",
    button: {
        checkout: "uiText.button.checkout",
        shoppingBag: "uiText.button.shoppingBag",
        logIn: "uiText.button.logIn",
        createAccount: "uiText.button.createAccount",
        logOut: "uiText.button.logout",
        allFilters: "uiText.button.allFilters",
        savePassword: "uiText.savePassword",
        cancel: "uiText.button.cancel",
        aria: {
            expand: "aria.button.expand",
        },
    },
    logInTitle: "uiText.logIn.title",
    createAccountTitle: "uiText.createAccount.title",
    error: {
        notAvailableShort: "uiText.error.notAvailable.short",
        notAvailableLong: "uiText.error.notAvailable.long",
        email: "uiText.error.email",
        dateOfBirth: "uiText.error.dateOfBirth",
        firstName: "checkout.step2.formFirstName.error",
        lastName: "checkout.step2.formLastName.error",
        emailOrPasswordError: "uiText.error.emailOrPassword",
        requiredFieldError: "uiText.error.requiredField",
        general: {
            title: "genericError.title",
            description: "genericError.description",
        },
        existingUserAccount: "uiText.error.existingUserAccount",
        existingAccountResetPassword: "uiText.error.existingAccountResetPassword",
        passwordRules: "uiText.error.passwordRules",
        maxCharacters: "uiText.error.maxCharacters",
        regionInCountry: "error.regionInCountry",
        onlyLocalShipping: "error.onlyLocalShipping",
        headlineFourOhFour: "uiText.error.404.headline",
        textFourOhFour: "uiText.error.404.text",
        headlineFiveHundred: "uiText.error.500.headline",
        textFiveHundred: "uiText.error.500.text",
        phone: "checkout.step1.formPhone.error",
        orderNumber: "uiText.error.orderNumber",
        countryCode: "uiText.error.countryCode",
        maxCommentCharacters: "uiText.error.maxCommentCharacters",
        passwordsDontMatch: "uiText.error.passwordsDontMatch",
        wrongPassword: "uiText.error.wrongPassword",
    },
    free: "uiText.free",
    cookieRenew: "uiText.cookieRenew",
    myAccount: "uiText.myAccount",
    help: "uiText.needHelp",
    ECCOMember: "uiText.ECCOMember",
    loggedInAs: "uiText.loggedInAs",
    notLoggedIn: "uiText.notLoggedIn",
    search: {
        seeAll: "search.seeAll",
    },
    searchBarPlaceholder: "uiText.searchBarPlaceholder",
    searchBarAriaIntro: "aria.searchBarAriaIntro",
    searchBarRecentSearches: "uiText.searchBarRecentSearches",
    searchBarPopularSearches: "uiText.searchBarPopularSearches",
    searchbarPlaceholder: "uiText.searchBarPlaceholder",
    searchbarPopularSearches: "uiText.searchBarPopularSearches",
    thankYouForSign: "uiText.thankYouForSign",
    edit: "uiText.edit",
    logInInvitation: "uiText.logInInvitation",
    loggedOut: "uiText.loggedOut",
    logBackButton: "uiText.logBackButton",
    usps: {
        userPanel: ["usps.first", "usps.second", "usps.third"],
        deliveryInfo: [
            "usps.deliveryInfo.first",
            "usps.deliveryInfo.second",
            "usps.deliveryInfo.third",
        ],
        selectSize: "usps.selectSize",
        availableInStore: "usps.availableInStore",
        availableInStores: "usps.availableInStores",
        seeOurStores: "usps.seeOurStores",
    },
    followUs: "uiText.followUs",
    backToTop: "uiText.backToTop",
    shoes: "uiText.shoes",
    other: "uiText.other",
    remove: "uiText.remove",
    generic: {
        readMore: "generic.readMore",
        readLess: "generic.readLess",
        readMoreAria: "generic.readMoreAria",
        readLessAria: "generic.readLessAria",
        true: "generic.true",
        false: "generic.false",
    },
    slide: {
        nextSlide: "uiText.nextSlide.text",
        previousSlide: "uiText.previousSlide.text",
        togglePlay: "uiText.togglePlay.text",
        toggleVolume: "uiText.toggleVolume.text",
    },
    orderNumber: "orderConfirmation.orderNumber",
    characterLeft: "characterLeft",
    charactersLeft: "charactersLeft",
    contactForm: {
        title: "uiText.contactForm.title",
        description: "uiText.contactForm.description",
        myQuestion: "uiText.contactForm.myQuestion",
        comment: "uiText.contactForm.comment",
        submitLabel: "uiText.contactForm.submitLabel",
        messageSent: "uiText.contactForm.messageSent",
        thankYouContact: "uiText.contactForm.thankYouContact",
        placeholders: {
            email: "uiText.contactForm.placeholders.email",
            firstName: "uiText.contactForm.placeholders.firstName",
            lastName: "uiText.contactForm.placeholders.lastName",
            phone: "uiText.contactForm.placeholders.phone",
            myQuestion: "uiText.contactForm.placeholders.myQuestion",
            orderNumber: "uiText.contactForm.placeholders.orderNumber",
            comment: "uiText.contactForm.placeholders.comment",
        },
        options: {
            cancelOrder: "uiText.contactForm.myQuestionOptions.cancelChangeOrder",
            generalInfo: "uiText.contactForm.myQuestionOptions.generalInfo",
            laceRequest: "uiText.contactForm.myQuestionOptions.laceRequest",
            myAccount: "uiText.contactForm.myQuestionOptions.myAccount",
            orderStatus: "uiText.contactForm.myQuestionOptions.orderStatus",
            other: "uiText.contactForm.myQuestionOptions.other",
            productInfo: "uiText.contactForm.myQuestionOptions.productInfo",
            return: "uiText.contactForm.myQuestionOptions.return",
            exchange: "uiText.contactForm.myQuestionOptions.exchange",
            shoeCare: "uiText.contactForm.myQuestionOptions.shoeCare",
            warranty: "uiText.contactForm.myQuestionOptions.warranty",
            website: "uiText.contactForm.myQuestionOptions.website",
            refunds: "uiText.contactForm.myQuestionOptions.refunds",
            promo: "uiText.contactForm.myQuestionOptions.promo",
            shipmentIssues: "uiText.contactForm.myQuestionOptions.shipmentIssues",
        },
    },
    giftWrapping: {
        modalTitle: "uiText.giftWrapping.title",
        label: "uiText.giftWrapping.label",
        link: "uiText.giftWrapping.link",
        free: "uiText.giftWrapping.free",
    },
};

export default CommonCMS;
